import Num, { BigNumber } from '@flipster/utils/num';

type DecimalInput = string | null | undefined;

export const toFiniteDecimal = (value: DecimalInput): BigNumber | null => {
  if (value === null || value === undefined) return null;

  const parsed = Num(value);
  return parsed.isFinite() ? parsed : null;
};

export const toPositiveDecimal = (value: DecimalInput): BigNumber | null => {
  const parsed = toFiniteDecimal(value);
  return parsed?.gt(0) ? parsed : null;
};

export const toNonNegativeDecimal = (value: DecimalInput): BigNumber | null => {
  const parsed = toFiniteDecimal(value);
  return parsed?.gte(0) ? parsed : null;
};
